import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateTimeline'
})
export class TranslateTimelinePipe implements PipeTransform {

  constructor(private translate: TranslateService) {}

  transform(): any[] {
    return [
      {
        tag: this.translate.instant('ADMIN_TOOL.RISK_MANAGEMENT.TIMELINES.CLOSURE.TAG'),
        title: this.translate.instant('ADMIN_TOOL.RISK_MANAGEMENT.TIMELINES.CLOSURE.TITLE'),
        byline: '',
        excerpt: this.translate.instant('ADMIN_TOOL.RISK_MANAGEMENT.TIMELINES.CLOSURE.EXCERPT'),
        action: {
          label: this.translate.instant('ADMIN_TOOL.RISK_MANAGEMENT.TIMELINES.CLOSURE.ACTION.LABEL'),
          event: this.translate.instant('ADMIN_TOOL.RISK_MANAGEMENT.TIMELINES.CLOSURE.ACTION.EVENT')
        }
      }
    ];
  }
}
